import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgHide(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.26 5.295l1.419 1.41-1.558 1.567c1 .947 1.96 2.19 2.879 3.728-2.388 4-5.054 6-8 6-1.216 0-2.384-.34-3.505-1.022l-1.766 1.8-1.427-1.401 1.598-1.63C5.892 14.8 4.925 13.55 4 12c2.388-4 5.054-6 8-6 1.224 0 2.4.346 3.529 1.037l1.731-1.742zm-1.547 4.393l-1.781 1.793a2 2 0 01-2.446 2.452L9.95 15.498a4.598 4.598 0 001.85.497L12 16c1.86 0 3.697-1.203 5.508-3.817L17.63 12l-.123-.183c-.596-.86-1.194-1.567-1.795-2.129zM12 8c-1.86 0-3.697 1.203-5.508 3.817L6.368 12l.124.183c.6.865 1.202 1.576 1.807 2.14l1.77-1.802a2 2 0 012.448-2.454l1.548-1.557a4.614 4.614 0 00-1.866-.505L12 8z"
      />
    </svg>
  );
}

export default tombacIcon('Hide')(SvgHide);
